import React, { Children, useEffect, useState } from 'react';
import ListItem from '@mui/material/ListItem';
import { Collapse, Icon, List } from '@mui/material';
import classNames from 'classnames';
import { materialOutlinedIconsClassName } from 'util/Layout';
import { ExpandLess, ExpandMore } from '@mui/icons-material';

import styles from '../Sidebar.module.scss';

interface SidebarMenuListButtonProps {
  icon: React.ReactNode;
  title: React.ReactNode;
  isOpen?: boolean;
}

const SidebarMenuListButton: React.FunctionComponent<SidebarMenuListButtonProps> = ({
  title,
  icon,
  isOpen,
  children,
}) => {
  const [open, setOpen] = useState<boolean>(false);

  useEffect(() => {
    if (isOpen) {
      setOpen(true);
    }
  }, [isOpen]);

  const handleClick = () => {
    setOpen(!open);
  };

  return Children.count(children) ? (
    <>
      <List className={styles.link}>
        <ListItem onClick={handleClick} className={styles.content}>
          <Icon className={classNames(materialOutlinedIconsClassName, styles.icon)}>{icon}</Icon>
          <span className={styles.label}>{title}</span>
          {open ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
      </List>
      <Collapse in={open} unmountOnExit={true}>
        {children}
      </Collapse>
    </>
  ) : null;
};

export default SidebarMenuListButton;
